<template>
  <div>
    <Modal v-model="visible" title="配置考核项" width="960" class="my-modal top" :mask-closable="false" :footer-hide="true">
      <Form v-if="showPupUp" ref="form" :model="formData" class="page-form" :label-width="90">
        <FormItem prop="rankName" label="考核职级">
          <span>{{ formData.rankName }}</span>
        </FormItem>
        <FormItem prop="type" label="考核类型">
          <RadioGroup v-model="formData.type" @on-change="getRankRules">
            <Radio label="2">晋升</Radio>
            <Radio label="3">维持</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem v-if="formData.type == 2" prop="newRankId" label="拟晋升职级" class="half">
          <Select v-model="formData.newRankId" transfer clearable filterable @on-select="selRank">
            <Option v-for="item in rankList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <div v-if="list && list.length">
          <div v-for="(item, index) in list" :key="index" class="rules-wrap">
            <div class="f-b rules-title">
              <span>考核方案{{ index + 1 | transCode }}</span>
              <Checkbox v-model="item.check" @on-change="val => changeRule(val, item)"></Checkbox>
            </div>
            <div class="case-box">
              <FormItem prop="caseName" label="方案名称">
                <span>{{ item.caseName }}</span>
              </FormItem>
              <FormItem class="btn-item">
              </FormItem>
              <div v-for="(rule, idx) in item.list" class="rules-box" :class="idx == 0 ? 'top-line' : ''" :key="idx">
                <FormItem prop="orgIds" label="考核指标" class=" ">
                  <span>{{ rule.ruleName }}</span>
                </FormItem>
                <FormItem prop="orgIds" label="考核条件" class=" ">
                  <span>{{ rule.ruleName }}</span>
                </FormItem>
                <FormItem class="btn-item">
                  <Checkbox v-model="rule.check" @on-change="val => changeSingleRule(val, item)"></Checkbox>
                </FormItem>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="empty">暂无可配置考核方案！</div>
      </Form>
      <div class="ivu-modal-footer">
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" @click="save">确认</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  props: [],
  components: {},
  filters: {
    transCode(val) {
      let num = ''
      switch (val) {
        case 1:
          num = '一'
          break;
        case 2:
          num = '二'
          break;
        case 3:
          num = '三'
          break;
        case 4:
          num = '四'
          break;
        case 5:
          num = '五'
          break;
        case 6:
          num = '六'
          break;
      }
      return num;
    }
  },
  data() {
    return {
      visible: false,
      showPupUp: false,
      rankList: [],
      commissionSelected: [],
      formData: {
        baseId: '',
        rankId: '',
        rankName: '',
        newRankId: '',
        type: '2',
      },
      list: [],//方案
      options: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now();
        }
      }
    };
  },
  methods: {
    changeRule(val, item) {
      item.list.forEach(el => {
        el.check = val;
      });
    },
    changeSingleRule(val, item) {
      item.check = item.list.every(i => i.check)
    },
    selRank(val) {
      this.formData.newRankId = val.value;
      this.getRankRules()
    },
    //获取职级
    getBaseRank() {
      return new Promise((resolve) => {
        this.$http({
          url: '/buz/baseRank/read/all',
          type: 'POST',
          data: {
            baseId: this.formData.baseId,
          },
        })
          .then((res) => {
            this.rankList = res.data
            if (res.data) {
              this.formData.rankName = res.data.find(i => i.id == this.formData.rankId).name;
              this.formData.newRankId = res.data.filter(i => i.id != this.formData.rankId)[0].id;
            }
            resolve('')
          })
          .catch((e) => {
          })
      })
    },
    getRankRules() {
      this.$http({
        url: '/buz/baseCommission/rankCommissions',
        type: 'GET',
        data: {
          rankId: this.formData.rankId,
          newRankId: this.formData.type == 2 ? this.formData.newRankId : undefined,
          type: this.formData.type,
        },
      })
        .then((res) => {
          let list = res.data.map(item => {
            item.list = item.list.map(i => {
              if ((this.formData.type == 2 && !this.formData.type1_id) || (this.formData.type == 3 && !this.formData.type2_id) || this.commissionSelected.includes(i.id)) {
                i.check = true;
              } else {
                i.check = false;
              }
              return i
            })
            if ((this.formData.type == 2 && !this.formData.type1_id) || (this.formData.type == 3 && !this.formData.type2_id) || item.list.every((i) => i.check)) {
              item.check = true;
            } else {
              item.check = false;
            }
            return item;
          });
          this.$nextTick(() => {
            let formData = JSON.parse(JSON.stringify(this.formData))
            this.formData = formData;
            this.list = list
            console.log(list)
          })
        })
        .catch((e) => { })
    },
    async open(data = {}, commissionSelected = []) {
      if (commissionSelected) {
        this.commissionSelected = commissionSelected;
      }
      data = JSON.parse(JSON.stringify(data));
      this.visible = true;
      this.showPupUp = true;
      this.list = [];
      this.$refs.form && this.$refs.form.resetFields();
      if (data.id) {
        console.log('data', data)
        this.formData.baseId = data.id;
        this.formData.rankId = data.rankId;
        this.formData.type = '2';
        this.formData.type1_id = data.type1_id;
        this.formData.type2_id = data.type2_id;
        await this.getBaseRank();
        this.getRankRules();
      }
    },

    save() {
      this.$refs.form.validate().then(isok => {
        if (!isok) {
          return;
        }
        let data = JSON.parse(JSON.stringify(this.formData))
        let params = {
          baseId: data.baseId,
          oldRankId: data.rankId,
          newRankId: data.newRankId,
          type: data.type,
          commissionSelected: []
        }
        let allIds = [];
        this.list.forEach(i => {
          i.list.forEach(item => {
            if (item.check) params.commissionSelected.push(item.id)
            allIds.push(item.id)
          })
        })
        console.log('params--', params)

        if (params.type == 2) {
          params.type = '1';
          params.id = data.type1_id;
        } else if (params.type == 3) {
          params.type = '2';
          params.id = data.type2_id;
          delete params.newRankId;
        }
        const hasData = allIds.find(item => this.commissionSelected.includes(item));
        console.log('allIds',allIds)
        console.log('hasData',hasData)
        if(!hasData) delete params.id;
        if(!hasData && params.commissionSelected.length == 0){
          this.visible = false;
          this.$notice.success('操作成功');
          this.$emit('success');
          return;
        }
        console.log(hasData)
        this.$http({
          url: hasData ? '/buz/promotionRule/update' : '/buz/promotionRule/save',
          type: 'POST',
          data: params
        }).then(res => {
          this.formData = {};
          this.$notice.success('操作成功');
          this.$emit('success')
          this.visible = false;
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.my-modal {
  .empty {
    color: #E3461F;
  }

  .flex {
    /deep/.ivu-form-item-content {
      display: flex;
      white-space: nowrap;
    }
  }

  .form {
    margin-top: 10px;
  }

  /deep/ {
    .ivu-modal-body {
      padding-top: 0;

      .ivu-form-item {
        width: 40%;
      }

      .full.ivu-form-item {
        width: 100% !important;

        .ivu-form-item-label {
          white-space: nowrap;
          width: 130px !important;
        }

        .ivu-form-item-content {
          margin-left: 130px !important;

          .ivu-radio-group {
            width: 100%;
          }

          .ivu-radio-wrapper {
            width: 40%;
          }

          .ivu-select {
            width: 70%;
            margin: 0 10px;
          }
        }
      }
    }
  }

  .rules-wrap {
    .rules-title {
      padding-right: 10px;
    }

    .f-b {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .case-box {
      border-radius: 4px;
      border: 1px solid #eee;
      padding: 24px 0 0;
      margin: 10px 0;

      .right {
        text-align: right;
        padding: 0 10px 24px;

        .btn-del {
          cursor: pointer;
          color: #236DFF;
        }
      }

      .btn-item {
        text-align: right;

        .btn-del {
          cursor: pointer;
          color: #236DFF;
        }

        width: 20%;

        /deep/.ivu-form-item-content {
          text-align: right;
        }

      }

      .top-line {
        border-top: 1px solid #eee;
        padding-top: 24px;
      }
    }
  }
}
</style>
